// THEME
// Para ver y generar paleta de colores ir a https://www.w3schools.com/w3css/w3css_color_generator.asp
// luego ingresar el valor de TH (por ejemplo: #d20000) y presionar el botón Create Theme

const Themes = [
        {
                L5: '#ecf5fe',
                L4: '#c0dffb',
                L3: '#82bff8',
                L2: '#439ff4',
                L1: '#0d7ee7',
                TH: '#0a5aa7',
                D1: '#095398',
                D2: '#084a87',
                D3: '#074076',
                D4: '#063765',
                D5: '#052e54'
        }
];
export default Themes;
